import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./ForgotPassword.html';
import styles from './ForgotPassword-hashed.scss';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';
import AuthComponentUtils from '../common/AuthComponentUtils';

// VARS
var hashedTemplate = cssUtil.hashTemplate(template, styles);

// EXPORT

export default {
    template: hashedTemplate,
    controller: ['auth.AuthLoginModal', '$scope', '$state', 'oAuth', function (AuthLoginModal, $scope, $state, oAuth) {
        // VARS
        var $ctrl = this;
        var authenticationService = AuthenticationService(oAuth);

        $ctrl.isForgotReqInProgress = false; // animation

        // METHODS
        var setCtrlParam = AuthComponentUtils.setCtrlParam($ctrl, $scope);

        function setError(value) {
            setCtrlParam('forgotPasswordError', value);
        }

        // Default model attr required by gw-pl-inline-ctrl-group directive
        $ctrl.email = {
            aspects: {
                get valid() {
                    var regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;
                    return regex.test($ctrl.email.value);
                }
            }
        };

        $ctrl.send = function () {

            if (!$ctrl.email.aspects.valid) {
                setError('fieldIncorrect');
                return;
            }

            setCtrlParam('isForgotReqInProgress', true); // animation
            authenticationService.forgotPassword($ctrl.email.value).then(function () {
                setCtrlParam('isForgotReqInProgress', false); // animation
                setCtrlParam('status', 'EMAIL_SENT');
            }).catch(function (err) {
                switch (err.error) {
                    case authenticationService.ERRORS.tokens.emailNotFound:
                        setCtrlParam('status', 'EMAIL_NOT_FOUND');
                        break;
                    default:
                        setCtrlParam('status', 'INVALID_ATTEMPT');
                        break;
                }
            });
        };

        $ctrl.backToSignIn = function () {
            $state.go('authLogin');
        };
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/ForgotPassword/index.js
// module id = 1329
// module chunks = 0